"use strict";
/* PLEASE no imports on this file! This file is shared with other projects. */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullValues = exports.ScreenViewPort = exports.CustomFormType = exports.CustomCleaningFields = exports.CustomFormFieldType = exports.locationValues = exports.ServicePortalType = exports.Portal = exports.FacilityBulkNoticeSteps = exports.NoticesType = exports.SendFacilityNoticeSteps = exports.DeviceCleaningNoticeSteps = exports.AddGeneralNoticeSteps = exports.AddNoticeSteps = exports.IndustriesBulkUpdate = exports.ImportSampleSteps = exports.LinkType = exports.DashboardWidgetFilterCategories = exports.DashboardWidgetTypes = exports.DeviceCleaningFrequencySettingFields = exports.TestFrequencySettingFields = exports.DeviceCleaningFrequencySettingTypes = exports.TestFrequencySettingTypes = exports.ServiceStatus = exports.FieldUpdatePolicy = exports.ImportEntityPolicy = exports.CccImportSteps = exports.RiskScoreValues = exports.ImportEntity = exports.CustomFieldApplyToTable = exports.ImportSteps = exports.BulkUpdateSteps = exports.ComplianceStatus = exports.AttachmentType = exports.ColumnField = exports.FilterObjectName = exports.FilterOperator = exports.FilterType = exports.FilterApplyTo = exports.LetterTemplateCategory = exports.CustomFieldDefinitionApplyTo = exports.CustomFieldDataType = exports.emptyOption = exports.emptyOptions = exports.printMarginUnitOptions = exports.dueDateOptions = exports.scheduleDueDateTimeOptions = exports.locationOptions = exports.yesNoBooleanOptions = exports.yesNoOptions = exports.noLongerInServiceDropDown = exports.CommentType = exports.FeatureNames = exports.ApiError = exports.setProp = exports.getProp = exports.MarginUnits = exports.OrganizationType = exports.NoticeTemplateType = exports.AutoNumberDomainType = exports.PermissionGroupName = exports.RegulatoryProgramName = exports.OrganizationTypeName = exports.IncidentContributorEntityType = exports.EntityMapLocationType = exports.SettingType = exports.SystemSettingType = exports.LocalStorageName = exports.NumberType = exports.SubLookupType = exports.LookupType = exports.UrlAction = exports.ApiPortal = exports.LoadStatus = exports.ApiEndpoints = exports.UploadMaximumSize10MB = exports.UploadMaximumSize50MB = exports.ContactCardType = exports.EntityContactNotice_NoticeType = exports.EntityContact_EntityType = exports.NoticeStatus = exports.MonthOffset = exports.Environment = exports.GridTypes = exports.ApiSignalTimeoutOneMin = exports.minimumAllowedDateForDatePicker = exports.AcpDomain = exports.MaxIntegerStr = exports.MaxInteger = void 0;
exports.MaxInteger = 2147483647; //C# Int32.MaxValue, e.g. Math.pow(2, 31) - 1
exports.MaxIntegerStr = `${exports.MaxInteger}`;
exports.AcpDomain = 'aquaticinformatics.net';
exports.minimumAllowedDateForDatePicker = '1900-01-01';
exports.ApiSignalTimeoutOneMin = 1 * 60 * 1000;
var GridTypes;
(function (GridTypes) {
    GridTypes["FogFacilities"] = "fogFacilities";
    GridTypes["Inspections"] = "inspections";
    GridTypes["Violations"] = "violations";
    GridTypes["Cleanings"] = "cleanings";
})(GridTypes = exports.GridTypes || (exports.GridTypes = {}));
var Environment;
(function (Environment) {
    Environment["Development"] = "Development";
    Environment["AutoServer"] = "AutoServer";
    Environment["Test"] = "Test";
    Environment["Beta"] = "Beta";
    Environment["Staging"] = "Staging";
    Environment["Production"] = "Production";
})(Environment = exports.Environment || (exports.Environment = {}));
var MonthOffset;
(function (MonthOffset) {
    MonthOffset[MonthOffset["ThreeMonths"] = 3] = "ThreeMonths";
    MonthOffset[MonthOffset["SixMonths"] = 6] = "SixMonths";
    MonthOffset[MonthOffset["OneYear"] = 12] = "OneYear";
    MonthOffset[MonthOffset["StartOfTimeOrEndOfTime"] = 600] = "StartOfTimeOrEndOfTime";
    MonthOffset[MonthOffset["Custom"] = 0] = "Custom";
})(MonthOffset = exports.MonthOffset || (exports.MonthOffset = {}));
var NoticeStatus;
(function (NoticeStatus) {
    NoticeStatus["Success"] = "success";
    NoticeStatus["Sent"] = "sent";
    NoticeStatus["Sending"] = "sending";
    NoticeStatus["Fail"] = "fail";
})(NoticeStatus = exports.NoticeStatus || (exports.NoticeStatus = {}));
var EntityContact_EntityType;
(function (EntityContact_EntityType) {
    EntityContact_EntityType["FogDevice"] = "FogDevice";
    EntityContact_EntityType["FogFacility"] = "FogFacility";
    EntityContact_EntityType["Hauler"] = "Hauler";
})(EntityContact_EntityType = exports.EntityContact_EntityType || (exports.EntityContact_EntityType = {}));
var EntityContactNotice_NoticeType;
(function (EntityContactNotice_NoticeType) {
    EntityContactNotice_NoticeType["FogCleaning"] = "FogCleaning";
})(EntityContactNotice_NoticeType = exports.EntityContactNotice_NoticeType || (exports.EntityContactNotice_NoticeType = {}));
var ContactCardType;
(function (ContactCardType) {
    ContactCardType["FogDevice"] = "FogDevice";
    ContactCardType["FogFacility"] = "FogFacility";
})(ContactCardType = exports.ContactCardType || (exports.ContactCardType = {}));
exports.UploadMaximumSize50MB = 50 * 1024 * 1024;
exports.UploadMaximumSize10MB = 10 * 1024 * 1024;
exports.ApiEndpoints = {
    Dashboard: 'dashboard',
    Users: 'Users',
    InternalUsers: 'InternalUsers',
    FogFacilities: 'Facilities',
    InspectionEvents: 'InspectionEvents',
    Attachments: 'Attachments',
    Contacts: 'Contacts',
    Equipment: 'Equipment',
    Comments: 'Comments',
    CallLogs: 'CallLogs',
    Haulers: 'Haulers',
    ExtractorTypes: 'ExtractorTypes',
    Extractors: 'Extractors',
    DraftFilters: 'DraftFilters',
    Filters: 'Filters',
    Emails: 'Emails',
    EmailLogs: 'EmailLogs',
    TestEmails: 'TestEmails',
    Enforcements: 'Enforcements',
    Violations: 'Violations',
    Cleanings: 'Cleanings',
    CleaningsByDomainObject: 'CleaningsByDomainObject',
    Jurisdictions: 'Jurisdictions',
    AuthorityDetails: 'AuthorityDetails',
    Settings: 'Settings',
    AuthoritySettings: 'AuthoritySettings',
    CustomFieldDefinitions: 'CustomFieldDefinitions',
    Frequencies: 'Frequencies',
    Units: 'Units',
    Inspections: 'Inspections',
    Lookups: 'Lookups',
    ContactTypes: 'ContactTypes',
    EquipmentTypes: 'EquipmentTypes',
    EventCategories: 'EventCategories',
    EventTypes: 'EventTypes',
    Tags: 'Tags',
    WasteTypes: 'WasteTypes',
    MapCategories: 'MapCategories',
    ReceivingPlants: 'ReceivingPlants',
    ViolationTypes: 'ViolationTypes',
    CorrectiveActions: 'CorrectiveActions',
    EnforcementTypes: 'EnforcementTypes',
    LetterTemplates: 'LetterTemplates',
    InspectionView: 'InspectionView',
    EmailView: 'EmailView',
    InspectionFormTemplates: 'InspectionFormTemplates',
    InspectionForms: 'InspectionForms',
    InspectionEventTypes: 'InspectionTypes',
    InspectionMaintenanceLogs: 'MaintenanceLogs',
    PumpOutEvents: 'PumpOutEvents',
    ResetPassword: 'ResetPassword',
    InspectionEmailTemplate: 'InspectionEmailTemplate',
    MaintenanceMessage: 'MaintenanceMessage',
    ACPDCErrorEmailRecipients: 'ACPDCErrorEmailRecipients',
    SystemSettings: 'SystemSettings',
    SystemAuthorities: 'SystemAuthorities',
    CustomFields: 'Settings/CustomFieldDefinitions',
    Devices: 'Devices',
    FogDevices: 'FogDevices',
    InternalIdMaps: 'InternalIdMaps',
    TimelineEvents: 'TimelineEvents',
    TermCondition: 'TermCondition',
    PrivacyPolicy: 'PrivacyPolicy',
    EntityMapLocation: 'EntityMapLocation',
    SaveDraftQuickFilterAsFilter: 'SaveDraftQuickFilterAsFilter',
    //Backflow API endpoints
    CccSites: 'Sites',
    CccDevice: 'Devices',
    CccDeviceType: 'DeviceTypes',
    CccHazards: 'Hazards',
    CccCompanies: 'Companies',
    CccImportConfigurations: 'Settings/AuthoritySettings/ImportConfigurations',
    CccImport: 'Settings/AuthoritySettings/Imports',
    CccImportHistories: 'Settings/AuthoritySettings/Imports/Histories',
    CccTechnicians: 'Technicians',
    CccTestKits: 'TestKits',
    CccNotices: 'Notices',
    CccTests: 'Tests',
    CccDataset: 'Datasets',
    ImportUniqueKey: 'Settings/ImportUniqueKey',
    SettingLookup: 'Settings/Lookups',
    SettingNoticeTemplateSchedule: 'Settings/NoticeTemplateSchedule',
    SettingNoticeTemplatesMergeFields: 'Settings/NoticeTemplates/MergeFields',
    NoticeHistories: 'SentNoticeHistories',
    CccLinkedContacts: 'LinkedContacts',
    PendingNoticeBatchStatus: 'checkCurrentBatchStatus',
    AdminOperation: 'operation',
    FireDailyCleaningNoticeJob: 'FireDailyCleaningNoticeJob',
    TranslationLanguages: 'TranslationLanguages',
    // IPP API endPoints
    IppAcpConnectorSettings: 'AcpConnectorSettings',
    IppIndustries: 'Industries',
    IppIndustry: 'Industry',
    IppAuditLogs: 'AuditLogs',
    IppUsers: 'Users',
    IppPendingInvitations: 'Invitations',
    IppPendingRegistration: 'Users',
    IppPendingRegistrationUserDetail: 'Users/:userId?isPendingUserApproval=true',
    IppSampleFlowUnits: 'Units/FlowUnits',
    IppFileUploadAttachmentTypes: 'ReportSettings/ReportElementTypes?ReportElementCategoryName=Attachments',
    IppUserLicenseUsedCount: 'Users/LicenseUsedCount',
    IppReportPackageTemplates: 'ReportSettings/ReportPackageTemplates',
    IppReportPackageReportElementTypes: 'ReportSettings/ReportElementTypes',
    IppCtsEventTypes: 'ReportSettings/CtsEventTypes',
    IppSampleFlowTemplate: 'ImportFileSettings/FileVersionFields',
    IppDownloadSampleFlowTemplate: 'ImportFileSettings/DownloadSampleImportInstructions',
    IppUnitTranslations: 'ImportFileSettings/Units',
    IppSystemUnits: 'ImportFileSettings/SystemUnits',
    IppDataSources: 'DataSources',
    IppDataProvidersDownload: 'DataSources/DownloadSampleImportInstructions',
    IppReportPackageParameterGroups: 'ReportSettings/ParameterGroups',
    IppReportPackageParameters: 'ReportSettings/Parameters',
    IppReportPackages: 'ReportPackages',
    IppFileStores: 'FileStores',
    IppDownloadPermitLimits: 'MonitoringPointParameterLimits/DownloadPermitLimits',
    IppDataSourceMonitoringPoint: 'DataSources/DataSourceMonitoringPoints',
    IppDataSourceCollectionMethods: 'DataSources/DataSourceCollectionMethods',
    IppDataSourceCtsEventTypes: 'DataSources/DataSourceCtsEventTypes',
    IppDataSourceParameters: 'DataSources/DataSourceParameters',
    IppDataSourceUnits: 'DataSources/DataSourceUnits',
    IppMonitoringPoints: 'MonitoringPoints',
    IppCollectionMethods: 'CollectionMethods',
    CtsEventTypes: 'CtsEventTypes',
    IppParameters: 'Parameters',
    IppUnits: 'Units',
    IppIndustrySamples: 'Samples',
    IppIndustryAttachments: 'FileStores',
    IppAttachment: 'attachment',
    IppSampleTypes: 'CtsEventTypes/?isForSample=true',
    IppFlowUnits: 'Settings/Units/FlowUnits',
    IppSampleParameterGroups: 'Samples/ParameterGroups',
    IppSampleFloatNumbers: 'Samples/FloatNumbersProduct',
    IppProgramSettings: 'Settings/ProgramSettings ',
    IppMassLoadingUnit: 'Settings/Units/MassLoadingUnitName',
    IppSampleParameters: 'ReportSettings/Parameters',
    InvitationDetails: 'InvitationDetails',
    IppDownloadCOR: 'COR/Download',
    IppValidateCOR: 'COR/Validate',
    IppPreviewReportPackage: 'Preview',
    IppSampleImport: 'SampleImports',
    DownloadSignatory: '/Account/DownloadSignatory',
    AllowedPortals: 'Account/AllowedPortals',
    ResetFailedAttemptCounts: 'Account/ResetFailedAttemptCounts',
    MaxAttachmentFileSizeInMB: 'Settings/IndustrySettings/MaxAttachmentFileSizeInMB',
    IppScheduledReports: 'ReportPackages/ScheduledReports',
    EmailNotifications: 'EmailNotifications',
    UpdateEmailNotification: 'EmailNotifications/UpdateEmailNotification',
    //Hauler Portal API End Point
    CheckIsExistingUser: 'checkIsExistingUser',
    TempUsers: 'tempUsers',
    Register: 'register',
    Invitation: 'invitation',
    Authorities: 'authorities',
    Hauler: 'hauler',
    ManageAuthorities: 'manageAuthorityAccess',
    UserEmailExists: 'users/getExistingHaulerUserIfNotInCurrentProgram',
    ResendHaulerInvite: 'users/resendInvite',
    ManageAccessHaulerUser: 'haulers/users',
    BlockAccess: 'blockAccess',
    HaulerPortalFacilities: '/hauler/facilities',
    HaulerDevices: '/hauler/devices',
    HaulerFacilities: 'HaulerFacilities',
    HaulerCleaningEvents: 'HaulerCleaningEvents',
    HaulerDeviceCleaningAttachment: 'Attachments/Upload',
    Select: 'Select',
    BlockAccessStatus: 'blockAccessStatus',
    CleaningNoticeTemplateSchedules: 'CleaningNoticeTemplateSchedules',
    HaulerCleaningHistory: 'CleaningManifests',
    HaulerPortalInvitationLetter: 'HaulerPortalInvitationLetter',
    HaulerPortalInvitationEmail: 'HaulerPortalInvitationEmail',
    HaulerPortalStatus: 'HaulerPortalStatus',
    ResendFacilityInvite: 'users/resendInvite',
    // Notices API End Points
    SendNotices: 'SendNotices',
    PreviewNotices: 'PreviewNotices',
    PreviewNotice: 'PreviewNotice',
    DownloadPreviewNotices: 'DownloadPreviewNotices',
    GeneralNotices: 'GeneralNotices',
    Preview: 'Preview',
    FacilityNoticeRecipient: 'facility/recipient',
    NoticeTemplates: 'NoticeTemplates',
    FacilityNoticeDevicesRecipient: 'facility/devicesRecipient',
    FogNoticesHistories: 'sentNoticeHistories',
    UploadAttachmentImage: 'attachments/image',
    SendEmails: 'sendEmails',
    SendCleaningNotice: 'sendCleaningNotice',
    downloadGeneralLetters: 'downloadGeneralLetters',
    SendNoticeContacts: 'SendNoticeContacts',
    NoticeExtractors: 'NoticeExtractors',
    Resend: 'resend',
    //Facility Portal API End Points
    FacilityPortalInvitationLetter: 'FacilityPortalInvitationLetter',
    FacilityEmail: 'FacilityEmail',
    FacilityPortalStatus: 'FacilityPortalStatus',
    GenerateInviteCode: 'GenerateInviteCode',
    DownloadInvite: 'DownloadInvite',
    PreviewInviteEmail: 'PreviewInviteEmail',
    SendInviteEmail: 'SendInviteEmail',
    FacilityRegister: 'Facility/register',
    ManageAccessFacilityUser: 'facilities/users',
    UserEmailExistsFacilityUser: 'users/getExistingFacilityUserIfNotInCurrentProgram',
    BusinessInformation: 'BusinessInformation',
    FacilityCleanings: 'facilityCleanings',
    FacilityCleaningEvents: 'FacilityCleaningEvents',
    DisposalLocations: 'DisposalLocations',
    businessInformation: 'BusinessInformation',
    FacilityCleaningHistory: 'CleaningManifests',
    DownloadAttachment: 'DownloadAttachment',
    Invite: 'Invite',
    FacilityAccessStatus: 'FacilityAccessStatus',
    Facility: 'facility',
    //Events API End Points
    Events: 'Events',
    GenericEvents: 'GenericEvents',
    //CustomForms
    CleaningCustomFormTemplates: 'CleaningCustomFormTemplates',
    CleaningCustomFormTemplate: 'CleaningCustomFormTemplate',
    CustomFormsSettings: 'settings/customForms',
    CleaningCustomForm: 'CleaningCustomForm',
    CustomCleaningManifests: 'CustomCleaningManifests',
    //Incident Endpoints
    IncidentTypes: 'IncidentTypes',
    IncidentSources: 'IncidentSources',
    IncidentStatuses: 'IncidentStatuses',
    Incidents: 'Incidents',
    IncidentContributors: 'IncidentContributors',
    // Fog Language Translation
    FogLanguageTranslationStatus: 'FogLanguageTranslationStatus'
};
var LoadStatus;
(function (LoadStatus) {
    LoadStatus["Ready"] = "Ready";
    LoadStatus["Loading"] = "Loading";
    LoadStatus["Loaded"] = "Loaded";
    LoadStatus["Processed"] = "Processed";
})(LoadStatus = exports.LoadStatus || (exports.LoadStatus = {}));
var ApiPortal;
(function (ApiPortal) {
    ApiPortal["Account"] = "Account";
    ApiPortal["Authority"] = "Authority";
})(ApiPortal = exports.ApiPortal || (exports.ApiPortal = {}));
var UrlAction;
(function (UrlAction) {
    UrlAction["HaulerRegistration"] = "haulerRegistration";
    UrlAction["InviteCodeConfirmed"] = "inviteCodeConfirmed";
    UrlAction["FacilityRegistration"] = "facilityRegistration";
})(UrlAction = exports.UrlAction || (exports.UrlAction = {}));
var LookupType;
(function (LookupType) {
    LookupType["NoteType"] = "NoteType";
    LookupType["InspectionMaintenanceResult"] = "InspectionMaintenanceResult";
    LookupType["ExtractorTypes"] = "ExtractorTypes";
    LookupType["EventCategory"] = "EventCategory";
    LookupType["ContactType"] = "ContactType";
    LookupType["MapCategory"] = "MapCategory";
    LookupType["ReceivingPlant"] = "ReceivingPlant";
    LookupType["ComplianceStatus"] = "ComplianceStatus";
    LookupType["Tag"] = "Tags";
    LookupType["EquipmentType"] = "EquipmentTypes";
    LookupType["CustomField"] = "CustomFieldDefinitions";
    LookupType["Events"] = "events";
    LookupType["ImportUniqueKey"] = "ImportUniqueKey";
    LookupType["EventType"] = "EventTypes";
    LookupType["CccSiteType"] = "CccSite.SiteType";
    LookupType["CccSiteUse"] = "CccSite.SiteUse";
    LookupType["CccHazardCategory"] = "HazardCategory";
    LookupType["CccHazardProtection"] = "Hazards.Protection";
    LookupType["CccHazardDeviceOrientation"] = "Hazards.Orientation";
    LookupType["CccHazardPriority"] = "HazardPriority";
    LookupType["CccHazardServiceStatus"] = "Hazards.ServiceStatus";
    LookupType["CccHazardServiceType"] = "Hazards.ServiceType";
    LookupType["CccHazardDeviceStatus"] = "DeviceStatus";
    LookupType["CccHazardLineSize"] = "Hazards.LineSize";
    LookupType["Dataset"] = "Dataset";
    LookupType["Unit"] = "Units";
    LookupType["Frequency"] = "Frequencies";
    LookupType["ViolationTypes"] = "ViolationTypes";
    LookupType["EnforcementTypes"] = "EnforcementTypes";
    LookupType["CorrectiveActions"] = "CorrectiveActions";
    LookupType["FogDeviceCleaningDisposalLocation"] = "FogDeviceCleaningDisposalLocation";
    LookupType["RepudiationReason"] = "RepudiationReason";
    LookupType["CleaningNoticeTemplateSchedule"] = "CleaningNoticeTemplateSchedules";
    LookupType["GeneralNoticeTemplate"] = "GeneralNoticeTemplate";
    LookupType["WasteType"] = "WasteTypes";
    LookupType["Hauler"] = "Hauler";
    LookupType["FogIncidentType"] = "FogIncidentType";
    LookupType["FogIncidentSource"] = "FogIncidentSource";
    LookupType["FogIncidentStatus"] = "FogIncidentStatus";
    LookupType["InspectionType"] = "InspectionType";
})(LookupType = exports.LookupType || (exports.LookupType = {}));
var SubLookupType;
(function (SubLookupType) {
    SubLookupType["Facility"] = "Facility";
    SubLookupType["Classification1"] = "FacilityClassification1";
    SubLookupType["Classification2"] = "FacilityClassification2";
    SubLookupType["InspectionEvent"] = "INSPECTION";
    SubLookupType["Hazard"] = "Hazard";
    SubLookupType["GENERIC"] = "GENERIC";
})(SubLookupType = exports.SubLookupType || (exports.SubLookupType = {}));
var NumberType;
(function (NumberType) {
    NumberType["CellPhone"] = "CellPhone";
    NumberType["BusinessPhone"] = "BusinessPhone";
    NumberType["Fax"] = "Fax";
    NumberType["Pager"] = "Pager";
    NumberType["EmergencyPhone"] = "EmerPhone";
})(NumberType = exports.NumberType || (exports.NumberType = {}));
var LocalStorageName;
(function (LocalStorageName) {
    LocalStorageName["Unspecified"] = "Unspecified";
    LocalStorageName["HaulerPortalToken"] = "haulerPortalToken";
    LocalStorageName["FacilityPortalToken"] = "facilityPortalToken";
    //FOG Program Grids
    LocalStorageName["FacilityGrid"] = "facilityGrid";
    LocalStorageName["FacilityGridFilterUrl"] = "facilityGridFilterUrl";
    LocalStorageName["FacilitySortOrder"] = "facilitySortOrder";
    LocalStorageName["FacilityTimelineFilter"] = "facilityTimelineFilter";
    LocalStorageName["FogDeviceGrid"] = "fogDeviceGrid";
    LocalStorageName["FogDeviceGridFilterUrl"] = "fogDeviceGridFilterUrl";
    LocalStorageName["FogDeviceSortOrder"] = "fogDeviceSortOrder";
    LocalStorageName["InspectionGrid"] = "inspectionGrid";
    LocalStorageName["InspectionGridFilterUrl"] = "inspectionGridFilterUrl";
    LocalStorageName["InspectionSortOrder"] = "inspectionSortOrder";
    LocalStorageName["ViolationGrid"] = "violationGrid";
    LocalStorageName["ViolationGridFilterUrl"] = "violationGridFilterUrl";
    LocalStorageName["ViolationSortOrder"] = "violationSortOrder";
    LocalStorageName["HaulerGrid"] = "haulerGrid";
    LocalStorageName["HaulerGridFilterUrl"] = "haulerGridFilterUrl";
    LocalStorageName["HaulerSortOrder"] = "haulerSortOrder";
    LocalStorageName["CleaningGrid"] = "cleaningGrid";
    LocalStorageName["CleaningGridFilterUrl"] = "cleaningGridFilterUrl";
    LocalStorageName["CleaningSortOrder"] = "cleaningSortOrder";
    LocalStorageName["FogImportHistorySortOrder"] = "fogImportHistorySortOrder";
    LocalStorageName["InspectionFormTemplateGrid"] = "InspectionFormTemplateGrid";
    LocalStorageName["FacilityMap"] = "facilityMap";
    LocalStorageName["FacilityMapCamera"] = "facilityMapCamera";
    LocalStorageName["IncidentGridFilterUrl"] = "incidentGridFilterUrl";
    //Backflow Program Grids
    LocalStorageName["SiteGrid"] = "siteGrid";
    LocalStorageName["CccSiteGridFilterUrl"] = "cccSiteGridFilterUrl";
    LocalStorageName["CccSiteSortOrder"] = "siteSortOrder";
    LocalStorageName["CccTimelineFilter"] = "cccTimelineFilter";
    LocalStorageName["CccHazardGrid"] = "cccHazardGrid";
    LocalStorageName["CccHazardGridFilterUrl"] = "cccHazardGridFilterUrl";
    LocalStorageName["CccHazardSortOrder"] = "hazardSortOrder";
    LocalStorageName["CccDevice"] = "cccDeviceGrid";
    LocalStorageName["CccDeviceGridFilterUrl"] = "cccDeviceGridFilterUrl";
    LocalStorageName["CccDeviceSortOrder"] = "cccDeviceSortOrder";
    LocalStorageName["CccNoticeGrid"] = "cccNoticeGrid";
    LocalStorageName["CccNoticesGridFilterUrl"] = "cccNoticesGridFilterUrl";
    LocalStorageName["CccNoticesSortOrder"] = "cccNoticesSortOrder";
    LocalStorageName["NoticeHistory"] = "noticeHistory";
    LocalStorageName["CccCompanyGrid"] = "cccCompanyGrid";
    LocalStorageName["CccTechnicianCompaniesGridFilterUrl"] = "cccTechnicianCompaniesGridFilterUrl";
    LocalStorageName["CccTechnicianCompaniesSortOrder"] = "cccTechnicianCompaniesSortOrder";
    LocalStorageName["CccTechnicianGrid"] = "cccTechnicianGrid";
    LocalStorageName["CccTechniciansGridFilterUrl"] = "cccTechniciansGridFilterUrl";
    LocalStorageName["CccTechniciansSortOrder"] = "cccTechniciansSortOrder";
    LocalStorageName["CccTestKitGrid"] = "cccTestKitGrid";
    LocalStorageName["CccTestKitsGridFilterUrl"] = "cccTestKitsGridFilterUrl";
    LocalStorageName["CccTestKitsSortOrder"] = "cccTestKitsSortOrder";
    LocalStorageName["cccImportHistoryGrid"] = "cccImportHistoryGrid";
    LocalStorageName["CccImportHistorySortOrder"] = "cccImportHistorySortOrder";
    //setting Program Grids
    LocalStorageName["UserGrid"] = "userGrid";
    LocalStorageName["UserGridSortOrder"] = "userGridSortOrder";
    LocalStorageName["SystemAuthority"] = "systemAuthorityGrid";
    LocalStorageName["OperationLog"] = "operationLogGrid";
    //dashboard
    LocalStorageName["FogDashboardWidgets"] = "fogDashboardWidgets";
    //inspection detail redirect
    LocalStorageName["InspectionDetailRedictFromPath"] = "inspectionDetailRedictFromPath";
    LocalStorageName["InspectionEditMode"] = "inspectionEditMode";
    //IPP Program Grids
    LocalStorageName["IppAuditLogGrid"] = "ippAuditLogGrid";
    LocalStorageName["IppAuditLogGridFilterUrl"] = "ippAuditLogGridFilterUrl";
    LocalStorageName["IppPendingRegistrationGrid"] = "IppPendingRegistrationGrid";
    LocalStorageName["IppUsersGrid"] = "ippUsersGrid";
    LocalStorageName["IppPendingInvitations"] = "ippPendingInvitations";
    LocalStorageName["IppIndustryGrid"] = "ippIndustriesGrid";
    LocalStorageName["IppIndustryGridFilterUrl"] = "ippIndustryGridFilterUrl";
    LocalStorageName["IppReportPackageTemplateGrid"] = "ippReportPackageTemplateGrid";
    LocalStorageName["IppReportPackageAttachmentGrid"] = "ippReportPackageAttachmentGrid";
    LocalStorageName["IppReportPackageCertificationGrid"] = "IppReportPackageCertificationGrid";
    LocalStorageName["IppDataProviderGrid"] = "ippDataProviderGrid";
    LocalStorageName["IppSampleImportTemplatesGrid"] = "ippSampleImportTemplatesGrid";
    LocalStorageName["IppUnitTranslationsGrid"] = "ippUnitTranslationsGrid";
    LocalStorageName["IppReportPackageParameterGroupsGrid"] = "IppReportPackageParameterGroupsGrid";
    LocalStorageName["IppReportPackageSubmittedPendingReviewGrid"] = "ippReportPackageSubmittedPendingReviewGrid";
    LocalStorageName["IppReportPackageRepudiatedPendingReviewGrid"] = "ippReportPackageRepudiatedPendingReviewGrid";
    LocalStorageName["IppReportPackageAll"] = "ippReportPackageAll";
    LocalStorageName["IppReportPackageError"] = "ippReportPackageCorruptedCOR";
    LocalStorageName["IppIndustrySamples"] = "ippIndustrySamplesGrid";
    LocalStorageName["IppIndustryReadyToReportSamples"] = "ippIndustryReadyToReportSamplesGrid";
    LocalStorageName["IppIndustryReportedSamples"] = "ippIndustryReportedSamplesGrid";
    LocalStorageName["IppIndustryAttachmentGrid"] = "ippIndustryAttachmentGrid";
    LocalStorageName["IppReportPackageScheduledGrid"] = "ippReportPackageScheduledGrid";
    LocalStorageName["IppReportPackageDraftGrid"] = "ippReportPackageDraftGrid";
    LocalStorageName["IppReportPackageReadyToSubmitGrid"] = "ippReportPackageReadyToSubmitGrid";
    LocalStorageName["IppReportPackageIndustryErrorsGrid"] = "ippReportPackageIndustryErrorsGrid";
    LocalStorageName["IppReportPackagePendingAcceptanceGrid"] = "ippReportPackagePendingAcceptanceGrid";
    LocalStorageName["IppReportPackageSubmittedGrid"] = "ippReportPackageSubmittedGrid";
    LocalStorageName["IppReportPackageRepudiatedGrid"] = "ippReportPackageRepudiatedGrid";
    LocalStorageName["IppReportPackageRejectedGrid"] = "ippReportPackageRejectedGrid";
    LocalStorageName["IppReportPackageAllGridFilterUrl"] = "ippReportPackageAllGridFilterUrl";
    LocalStorageName["IppReportPackageSubmittedGridFilterUrl"] = "ippReportPackageSubmittedGridFilterUrl";
    LocalStorageName["IppReportPackageRepudiatedGridFilterUrl"] = "ippReportPackageRepudiatedGridFilterUrl";
    LocalStorageName["IppReportPackageRejectedGridFilterUrl"] = "ippReportPackageRejectedGridFilterUrl";
    LocalStorageName["IppAttachmentGridFilterUrl"] = "ippAttachmentGridFilterUrl";
    LocalStorageName["IppReportedSampleGridFilterUrl"] = "ippReportedSampleFilterUrl";
    LocalStorageName["IppSampleGridFilterUrl"] = "ippSampleFilterUrl";
    LocalStorageName["IppSubmittedPendingReviewsReportPackageSortOrder"] = "ippSubmittedPendingReviewsReportPackageSortOrder";
    LocalStorageName["IppRepudiationPendingReviewsReportPackageSortOrder"] = "ippRepudiationPendingReviewsReportPackageSortOrder";
    LocalStorageName["IppAllReportPackageSortOrder"] = "ippAllReportPackageSortOrder";
    LocalStorageName["IppErrorReportPackageSortOrder"] = "ippCorruptedCORReportPackageSortOrder";
    LocalStorageName["recipientNotices"] = "recipientNotices";
    LocalStorageName["IppReportPackageSubmittedPendingReviewGridFilterUrl"] = "ippReportPackageSubmittedPendingReviewGridFilterUrl";
    LocalStorageName["IppReportPackageRepudiatedPendingReviewGridFilterUrl"] = "ippReportPackageRepudiatedPendingReviewGridFilterUrl";
    //Hauler Portal Grids
    LocalStorageName["HaulerPortalAuthorities"] = "haulerPortalAuthorities";
    LocalStorageName["HaulerPortalFacilityDevices"] = "haulerPortalFacilityDevices";
    LocalStorageName["HaulerPortalFacilityDevicesFilterUrl"] = "haulerPortalFacilityDevicesFilterUrl";
    LocalStorageName["HaulerPortalFacilityDevicesSortOrder"] = "haulerPortalFacilityDevicesSortOrder";
    LocalStorageName["HaulerPortalFacilities"] = "haulerPortalFacilities";
    LocalStorageName["HaulerPortalFacilitiesFilterUrl"] = "haulerPortalFacilitiesFilterUrl";
    LocalStorageName["HaulerPortalFacilitiesSortOrder"] = "haulerPortalFacilitiesSortOrder";
    LocalStorageName["HaulerPortalSelectFacilities"] = "haulerPortalSelectFacilities";
    LocalStorageName["HaulerPortalSelectFacilitiesFilterUrl"] = "haulerPortalSelectFacilitiesFilterUrl";
    LocalStorageName["HaulerPortalSelectFacilitiesSortOrder"] = "haulerPortalSelectFacilitiesSortOrder";
    LocalStorageName["HaulerPortalUserGridSortOrder"] = "haulerPortalUserGridSortOrder";
    LocalStorageName["HaulerPortalUsersGrid"] = "haulerPortalUsersGrid";
    LocalStorageName["HaulerPortalCleaningHistory"] = "haulerPortalCleaningHistory";
    LocalStorageName["FacilityNoticeRecipient"] = "facilityRecipientNotice";
    LocalStorageName["FacilityNoticeDevicesRecipient"] = "facilityNoticeDevicesRecipient";
    LocalStorageName["FogFacilityDevicesGrid"] = "FogFacilityDevicesGrid";
    LocalStorageName["FogFacilityDevicesFilterUrl"] = "FogFacilityDevicesFilterUrl";
    LocalStorageName["FogFacilityDevicesSortOrder"] = "FogFacilityDevicesSortOrder";
    LocalStorageName["FogNoticeGrid"] = "FogNoticeGrid";
    LocalStorageName["FogNoticesGridFilterUrl"] = "FogNoticesGridFilterUrl";
    LocalStorageName["FogNoticesSortOrder"] = "FogNoticesSortOrder";
    LocalStorageName["FogNoticesHistoryGrid"] = "FogNoticesHistoryGrid";
    LocalStorageName["FogNoticesHistoryFilterUrl"] = "FogNoticesHistoryFilterUrl";
    LocalStorageName["FogNoticesHistorySortOrder"] = "FogNoticesHistorySortOrder";
    LocalStorageName["FacilityPortalUsersGrid"] = "facilityPortalUsersGrid";
    LocalStorageName["FacilityPortalUsersGridSortOrder"] = "facilityPortalGridSortOrder";
    LocalStorageName["FacilityPortalCleaningHistories"] = "facilityPortalCleaningHistories";
    LocalStorageName["FacilityPortalCleaningHistoryFilterUrl"] = "facilityPortalCleaningHistoryFilterUrl";
    LocalStorageName["FacilityPortalCleaningHistorySortOrder"] = "facilityPortalCleaningHistorySortOrder";
    LocalStorageName["FacilityPortalFacilitiesGrid"] = "FacilityPortalFacilitiesGrid";
    LocalStorageName["FacilityPortalFacilitiesGridSortOrder"] = "facilityPortalFacilitiesGridSortOrder";
    LocalStorageName["FacilityPortalDevices"] = "facilityPortalDevices";
    LocalStorageName["FacilityPortalDevicesFilterUrl"] = "facilityPortalDevicesFilterUrl";
    LocalStorageName["FacilityPortalDevicesSortOrder"] = "facilityPortalDevicesSortOrder";
    LocalStorageName["EventsGrid"] = "eventsGrid";
    LocalStorageName["EventsSortOrder"] = "eventsSortOrder";
    LocalStorageName["EventsFilterUrl"] = "eventsFilterUrl";
    LocalStorageName["IncidentsGrid"] = "incidentsGrid";
    LocalStorageName["IncidentsSortOrder"] = "incidentsSortOrder";
    LocalStorageName["IncidentsFilterUrl"] = "incidentsFilterUrl";
    LocalStorageName["CustomForm"] = "customFormsGrid";
    LocalStorageName["CustomFormSort"] = "customFormSortOrder";
    LocalStorageName["DisplayLanguage"] = "displayLanguage";
})(LocalStorageName = exports.LocalStorageName || (exports.LocalStorageName = {}));
var SystemSettingType;
(function (SystemSettingType) {
    SystemSettingType["SystemMaintenanceMessageIsEnabled"] = "SystemMaintenanceMessageIsEnabled";
    SystemSettingType["SystemMaintenanceMessageText"] = "SystemMaintenanceMessageText";
    SystemSettingType["CTSDatabaseMinVersion"] = "CTSDatabaseMinVersion";
    SystemSettingType["DCMinVersion"] = "DCMinVersion";
})(SystemSettingType = exports.SystemSettingType || (exports.SystemSettingType = {}));
var SettingType;
(function (SettingType) {
    SettingType["Tags"] = "Tags";
    SettingType["FailedPasswordAttemptMaxCount"] = "FailedPasswordAttemptMaxCount";
    SettingType["FailedKBQAttemptMaxCount"] = "FailedKBQAttemptMaxCount";
    SettingType["InvitationExpiredHours"] = "InvitationExpiredHours";
    SettingType["PasswordChangeRequiredDays"] = "PasswordChangeRequiredDays";
    SettingType["PasswordHistoryMaxCount"] = "PasswordHistoryMaxCount";
    SettingType["TimeZone"] = "TimeZone";
    SettingType["EmailContactReplyToEmailAddress"] = "EmailContactReplyToEmailAddress";
    SettingType["EmailServerAddress"] = "EmailServerAddress";
    SettingType["EmailServerPortNumber"] = "EmailServerPortNumber";
    SettingType["EmailServerUserName"] = "EmailServerUserName";
    SettingType["EmailServerPassword"] = "EmailServerPassword";
    SettingType["EmailServerIsEnableSsl"] = "EmailServerIsEnableSsl";
    SettingType["EmailProtocol"] = "EmailProtocol";
    SettingType["EmailServerEncryption"] = "EmailServerEncryption";
    SettingType["EmailServerSenderDefaultEmailAddress"] = "EmailServerSenderDefaultEmailAddress";
    SettingType["EmailServerType"] = "EmailServerType";
    SettingType["ReportRepudiatedDays"] = "ReportRepudiatedDays";
    SettingType["ComplianceDeterminationDate"] = "ComplianceDeterminationDate";
    SettingType["MassLoadingConversionFactorPounds"] = "MassLoadingConversionFactorPounds";
    SettingType["MassLoadingResultToUseLessThanSign"] = "MassLoadingResultToUseLessThanSign";
    SettingType["MassLoadingCalculationDecimalPlaces"] = "MassLoadingCalculationDecimalPlaces";
    SettingType["EmailContactInfoName"] = "EmailContactInfoName";
    SettingType["EmailContactInfoPhone"] = "EmailContactInfoPhone";
    SettingType["EmailContactInfoEmailAddress"] = "EmailContactInfoEmailAddress";
    SettingType["AuthorityUserLicenseTotalCount"] = "AuthorityUserLicenseTotalCount";
    SettingType["IndustryLicenseTotalCount"] = "IndustryLicenseTotalCount";
    SettingType["UserPerIndustryMaxCount"] = "UserPerIndustryMaxCount";
    SettingType["ResultQualifierValidValues"] = "ResultQualifierValidValues";
    SettingType["FlowUnitValidValues"] = "FlowUnitValidValues";
    SettingType["SampleNameCreationRule"] = "SampleNameCreationRule";
    SettingType["SendToCtsDatabaseServerName"] = "SendToCtsDatabaseServerName";
    SettingType["SendToCtsDatabaseName"] = "SendToCtsDatabaseName";
    SettingType["ReportElementTypeIdForIndustryFileUpload"] = "ReportElementTypeIdForIndustryFileUpload";
    SettingType["ComplianceStatusValues"] = "ComplianceStatusValues";
    SettingType["CustomFields"] = "CustomFields";
    SettingType["TestScheduleFrequencyOption"] = "TestScheduleFrequencyOption";
    SettingType["TestScheduleFrequencyId"] = "TestScheduleFrequencyId";
    SettingType["DeviceCleaningScheduleFrequencyId"] = "DeviceCleaningScheduleFrequencyId";
    SettingType["DeviceCleaningScheduleFrequencyOption"] = "DeviceCleaningScheduleFrequencyOption";
    SettingType["FogDeviceCleaningDisposalLocation"] = "FogDeviceCleaningDisposalLocation";
    SettingType["SystemEmailServerSenderDefaultEmailAddress"] = "SystemEmailServerSenderDefaultEmailAddress";
    SettingType["DefaultDeviceCleaningScheduleFrequencyId"] = "DefaultDeviceCleaningScheduleFrequencyId";
    SettingType["DefaultDeviceCleaningScheduleFrequencyOption"] = "DefaultDeviceCleaningScheduleFrequencyOption";
})(SettingType = exports.SettingType || (exports.SettingType = {}));
var EntityMapLocationType;
(function (EntityMapLocationType) {
    EntityMapLocationType["FogFacility"] = "FogFacility";
    EntityMapLocationType["Incident"] = "Incident";
})(EntityMapLocationType = exports.EntityMapLocationType || (exports.EntityMapLocationType = {}));
var IncidentContributorEntityType;
(function (IncidentContributorEntityType) {
    IncidentContributorEntityType["FogFacility"] = "FogFacility";
})(IncidentContributorEntityType = exports.IncidentContributorEntityType || (exports.IncidentContributorEntityType = {}));
var OrganizationTypeName;
(function (OrganizationTypeName) {
    OrganizationTypeName["Authority"] = "Authority";
    OrganizationTypeName["Industry"] = "Industry";
    OrganizationTypeName["Facility"] = "Facility";
    OrganizationTypeName["Hauler"] = "Hauler";
})(OrganizationTypeName = exports.OrganizationTypeName || (exports.OrganizationTypeName = {}));
var RegulatoryProgramName;
(function (RegulatoryProgramName) {
    RegulatoryProgramName["IPP"] = "IPP";
    RegulatoryProgramName["FOG"] = "FOG";
    RegulatoryProgramName["Backflow"] = "BACKFLOW";
    RegulatoryProgramName["HAULER"] = "HAULER";
    RegulatoryProgramName["FACILITY"] = "FACILITY";
})(RegulatoryProgramName = exports.RegulatoryProgramName || (exports.RegulatoryProgramName = {}));
var PermissionGroupName;
(function (PermissionGroupName) {
    PermissionGroupName["Administrator"] = "Administrator";
})(PermissionGroupName = exports.PermissionGroupName || (exports.PermissionGroupName = {}));
var AutoNumberDomainType;
(function (AutoNumberDomainType) {
    AutoNumberDomainType["Facility"] = "Facility";
    AutoNumberDomainType["Hauler"] = "Hauler";
    AutoNumberDomainType["CccHazard"] = "CccHazard";
    AutoNumberDomainType["CccSite"] = "CccSite";
    AutoNumberDomainType["Devices"] = "FogDevice";
    AutoNumberDomainType["Incident"] = "FogIncident";
})(AutoNumberDomainType = exports.AutoNumberDomainType || (exports.AutoNumberDomainType = {}));
var NoticeTemplateType;
(function (NoticeTemplateType) {
    NoticeTemplateType["FogCleaningNotice"] = "FogCleaningNotice";
    NoticeTemplateType["FogGeneralFacilityNotice"] = "FogGeneralFacilityNotice";
    NoticeTemplateType["HaulerPortalInvitationLetter"] = "HaulerPortalInvitationLetter";
    NoticeTemplateType["HaulerPortalInvitationEmail"] = "HaulerPortalInvitationEmail";
    NoticeTemplateType["FacilityPortalInvitationLetter"] = "FacilityPortalInvitationLetter";
    NoticeTemplateType["InspectionEmailTemplate"] = "InspectionEmailTemplate";
    NoticeTemplateType["FacilityEmail"] = "FacilityEmailTemplate";
})(NoticeTemplateType = exports.NoticeTemplateType || (exports.NoticeTemplateType = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType[OrganizationType["Authority"] = 1] = "Authority";
    OrganizationType[OrganizationType["Industry"] = 2] = "Industry";
    OrganizationType[OrganizationType["Facility"] = 3] = "Facility";
    OrganizationType[OrganizationType["CccSite"] = 4] = "CccSite";
    OrganizationType[OrganizationType["Hauler"] = 5] = "Hauler";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
var MarginUnits;
(function (MarginUnits) {
    MarginUnits["Inches"] = "Inches";
    MarginUnits["Centimeters"] = "Centimeters";
})(MarginUnits = exports.MarginUnits || (exports.MarginUnits = {}));
exports.getProp = (obj, prop) => {
    if (obj.hasOwnProperty(prop)) {
        let value = obj[prop];
        if (value) {
            return value;
        }
        if (value === null) {
            return null;
        }
    }
    let propInLowerCase = prop.toLowerCase();
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && key.toLowerCase() === propInLowerCase) {
            return obj.key;
        }
    }
};
exports.setProp = (obj, prop, value) => {
    if (obj.hasOwnProperty(prop)) {
        obj.prop = value;
        return true;
    }
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && key.toLowerCase() === prop.toLowerCase()) {
            obj.key = value;
            return true;
        }
    }
    return false;
};
class ApiError {
    constructor(statusCode, statusText, requestUrl, jsonBody, text = '') {
        this.type = 'ApiError';
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.requestUrl = requestUrl;
        this.body = jsonBody;
        this.text = text;
        this.message = '';
        if (jsonBody != null) {
            let message = jsonBody.message || '';
            let internalMessage = jsonBody.internalMessage || '';
            this.message =
                message === internalMessage ? message : internalMessage ? internalMessage + ' ' + message : message;
            this.stackTrace = jsonBody.stackTrace || '';
            this.errorFields = jsonBody.errorFields || [];
        }
    }
}
exports.ApiError = ApiError;
var FeatureNames;
(function (FeatureNames) {
    FeatureNames["AutomationTest"] = "AutomationTest";
    FeatureNames["FeedBackForm"] = "FeedbackForm";
    FeatureNames["CCC"] = "CCC";
    FeatureNames["WithAqiIdentityProvider"] = "WithAqiIdentityProvider";
    FeatureNames["ShowInDevelopmentFeature"] = "ShowInDevelopmentFeature";
    FeatureNames["ShowPreferredHaulerFeature"] = "ShowPreferredHaulerFeature";
    FeatureNames["ShowCustomCleaningFormsFeature"] = "ShowCustomCleaningFormsFeature";
    FeatureNames["ShowFogMapFeature"] = "ShowFogMapFeature";
    FeatureNames["ShowFogIncidentFeature"] = "ShowFogIncidentFeature";
})(FeatureNames = exports.FeatureNames || (exports.FeatureNames = {}));
var CommentType;
(function (CommentType) {
    CommentType["Site"] = "Site";
    CommentType["Hazard"] = "Hazard";
    CommentType["FogDevice"] = "FogDevice";
})(CommentType = exports.CommentType || (exports.CommentType = {}));
exports.noLongerInServiceDropDown = [
    { label: 'Yes', value: false },
    { label: 'No', value: true }
];
exports.yesNoOptions = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
];
exports.yesNoBooleanOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];
exports.locationOptions = [
    { label: 'Inside', value: 'Inside' },
    { label: 'Outside', value: 'Outside' }
];
exports.scheduleDueDateTimeOptions = [
    {
        label: 'days',
        value: 'DAY'
    },
    {
        label: 'weeks',
        value: 'WEEK'
    },
    {
        label: 'months',
        value: 'MONTH'
    },
    {
        label: 'years',
        value: 'YEAR'
    }
];
exports.dueDateOptions = [
    {
        label: 'before',
        value: 'true'
    },
    {
        label: 'after',
        value: 'false'
    }
];
exports.printMarginUnitOptions = [
    {
        label: MarginUnits.Inches,
        value: MarginUnits.Inches
    },
    {
        label: MarginUnits.Centimeters,
        value: MarginUnits.Centimeters
    }
];
exports.emptyOptions = [];
exports.emptyOption = { label: '', value: '' };
var CustomFieldDataType;
(function (CustomFieldDataType) {
    CustomFieldDataType["Text"] = "Text";
    CustomFieldDataType["TextArea"] = "TextArea";
    CustomFieldDataType["Number"] = "Number";
    CustomFieldDataType["Date"] = "Date";
    CustomFieldDataType["Link"] = "Link";
    CustomFieldDataType["SingleValueDropDown"] = "SingleValueDropDown";
})(CustomFieldDataType = exports.CustomFieldDataType || (exports.CustomFieldDataType = {}));
var CustomFieldDefinitionApplyTo;
(function (CustomFieldDefinitionApplyTo) {
    CustomFieldDefinitionApplyTo["FogFacility"] = "tFogFacility";
    CustomFieldDefinitionApplyTo["CccSite"] = "tCccSite";
    CustomFieldDefinitionApplyTo["CccHazard"] = "tCccHazard";
})(CustomFieldDefinitionApplyTo = exports.CustomFieldDefinitionApplyTo || (exports.CustomFieldDefinitionApplyTo = {}));
var LetterTemplateCategory;
(function (LetterTemplateCategory) {
    LetterTemplateCategory["FacilityEmail"] = "FacilityEmail";
    LetterTemplateCategory["FacilityLetter"] = "FacilityLetter";
    LetterTemplateCategory["InspectionEmail"] = "InspectionEmail";
    LetterTemplateCategory["InspectionLetter"] = "InspectionLetter";
    LetterTemplateCategory["PumpOutEmail"] = "PumpOutEmail";
    LetterTemplateCategory["PumpOutLetter"] = "PumpOutLetter";
    LetterTemplateCategory["Others"] = "Others";
    LetterTemplateCategory["DeviceEmail"] = "DeviceEmail";
})(LetterTemplateCategory = exports.LetterTemplateCategory || (exports.LetterTemplateCategory = {}));
var FilterApplyTo;
(function (FilterApplyTo) {
    FilterApplyTo["Facility"] = "Facility";
    FilterApplyTo["Inspection"] = "Inspection";
    FilterApplyTo["IppSample"] = "IppSample";
    FilterApplyTo["IppFileStore"] = "IppFileStore";
})(FilterApplyTo = exports.FilterApplyTo || (exports.FilterApplyTo = {}));
var FilterType;
(function (FilterType) {
    FilterType["Text"] = "text";
    FilterType["Number"] = "number";
    FilterType["Integer"] = "integer";
    FilterType["Date"] = "date";
    FilterType["Boolean"] = "boolean";
    FilterType["Enum"] = "enum";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Is"] = "in";
    FilterOperator["IsNot"] = "nin";
    FilterOperator["Eq"] = "eq";
    FilterOperator["NotEqual"] = "neq";
    FilterOperator["LessThan"] = "lt";
    FilterOperator["LessThanEqual"] = "lte";
    FilterOperator["GreaterThan"] = "gt";
    FilterOperator["GreaterThanEqual"] = "gte";
    FilterOperator["IsBetween"] = "betw";
    FilterOperator["IsBetween2"] = "betw2";
    FilterOperator["Contains"] = "cont";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
var FilterObjectName;
(function (FilterObjectName) {
    FilterObjectName["Facility"] = "facility";
    FilterObjectName["Site"] = "site";
    FilterObjectName["Contact"] = "contact";
    FilterObjectName["Extractor"] = "extractor";
    FilterObjectName["Device"] = "device";
    FilterObjectName["Inspection"] = "inspection";
    FilterObjectName["Cleaning"] = "cleaning";
    FilterObjectName["CccSite"] = "cccSite";
    FilterObjectName["CccHazard"] = "cccHazard";
    FilterObjectName["Violation"] = "violation";
    FilterObjectName["Event"] = "event";
    FilterObjectName["Incident"] = "incident";
    FilterObjectName["IppCromerrAuditLog"] = "IppCromerrAuditLog";
    FilterObjectName["IppRepudiatedReportPackage"] = "IppRepudiatedReportPackage";
    FilterObjectName["IppSubmittedReportPackage"] = "IppSubmittedReportPackage";
    FilterObjectName["IppAllReportPackage"] = "IppAllReportPackage";
    FilterObjectName["IppCorruptedCORReportPackage"] = "IppCorruptedCORReportPackage";
    FilterObjectName["IppReportPackage"] = "IppReportPackage";
    FilterObjectName["IppFileStore"] = "IppFileStore";
    FilterObjectName["IppReportedSample"] = "IppReportedSample";
    FilterObjectName["IppIndustry"] = "IppIndustry";
    FilterObjectName["IppSample"] = "IppSample";
    FilterObjectName["IppSubmittedPendingReviewReportPackage"] = "IppSubmittedPendingReviewReportPackage";
    FilterObjectName["IppRepudiatedPendingReviewReportPackage"] = "IppRepudiatedPendingReviewReportPackage";
})(FilterObjectName = exports.FilterObjectName || (exports.FilterObjectName = {}));
class ColumnField {
    constructor(name, type = FilterType.Text, cellFormatter, isDefault = false, sortable = true, locked = false, translateable = false, gridColumnPropsOverrides) {
        this.name = name;
        this.type = type;
        this.cell = cellFormatter;
        this.isDefault = isDefault;
        this.sortable = sortable;
        this.locked = locked;
        this.translateable = translateable;
        this.gridColumnPropsOverrides = gridColumnPropsOverrides;
    }
}
exports.ColumnField = ColumnField;
ColumnField.newText = (name, isDefault = false, cellFormatter, sortable = true, locked = false, translateable = false) => {
    return new ColumnField(name, FilterType.Text, cellFormatter, isDefault, sortable, locked, translateable);
};
ColumnField.newNumber = (name, isDefault = false, cellFormatter, sortable = true, locked = false) => {
    return new ColumnField(name, FilterType.Number, cellFormatter, isDefault, sortable, locked);
};
ColumnField.newInteger = (name, isDefault = false, cellFormatter, sortable = true, locked = false) => {
    return new ColumnField(name, FilterType.Integer, cellFormatter, isDefault, sortable, locked);
};
ColumnField.newDate = (name, isDefault = false, cellFormatter, sortable = true, locked = false) => {
    return new ColumnField(name, FilterType.Date, cellFormatter, isDefault, sortable, locked);
};
ColumnField.newBoolean = (name, isDefault = false, cellFormatter, sortable = true, locked = false) => {
    return new ColumnField(name, FilterType.Boolean, cellFormatter, isDefault, sortable, locked);
};
var AttachmentType;
(function (AttachmentType) {
    AttachmentType["InspectionAttachment"] = "InspectionAttachment";
    AttachmentType["FogDeviceCleaning"] = "FogDeviceCleaning";
    AttachmentType["FogDevice"] = "FogDevice";
    AttachmentType["FogIncident"] = "FogIncident";
    AttachmentType["FogGenericEvent"] = "FogGenericEvent";
})(AttachmentType = exports.AttachmentType || (exports.AttachmentType = {}));
var ComplianceStatus;
(function (ComplianceStatus) {
    ComplianceStatus["NonCompliant"] = "Non Compliant";
    ComplianceStatus["Compliant"] = "Compliant";
    ComplianceStatus["Unknown"] = "Unknown";
})(ComplianceStatus = exports.ComplianceStatus || (exports.ComplianceStatus = {}));
var BulkUpdateSteps;
(function (BulkUpdateSteps) {
    BulkUpdateSteps["STEP1_CHOOSE_FIELDS"] = "choseFields";
    BulkUpdateSteps["STEP2_INPUT_VALUES"] = "inputValues";
    BulkUpdateSteps["STEP3_SUMMARY"] = "bulkUpdateSummary";
})(BulkUpdateSteps = exports.BulkUpdateSteps || (exports.BulkUpdateSteps = {}));
// authoritySettings-import
var ImportSteps;
(function (ImportSteps) {
    ImportSteps["STEP1"] = "choose-a-file";
    ImportSteps["STEP2"] = "preview";
    ImportSteps["STEP3"] = "results";
})(ImportSteps = exports.ImportSteps || (exports.ImportSteps = {}));
var CustomFieldApplyToTable;
(function (CustomFieldApplyToTable) {
    CustomFieldApplyToTable["ApplyToFogFacility"] = "tFogFacility";
    CustomFieldApplyToTable["ApplyToCccSite"] = "tCccSite";
    CustomFieldApplyToTable["ApplyToCccHazard"] = "tCccHazard";
    CustomFieldApplyToTable["ApplyToCccSiteContact"] = "tCccSiteContact";
})(CustomFieldApplyToTable = exports.CustomFieldApplyToTable || (exports.CustomFieldApplyToTable = {}));
var ImportEntity;
(function (ImportEntity) {
    ImportEntity["CccSite"] = "CccSite";
    ImportEntity["CccHazard"] = "CccHazard";
    ImportEntity["CccContact"] = "CccContact";
    ImportEntity["FogFacility"] = "FogFacility";
    ImportEntity["FogContact"] = "FogContact";
    ImportEntity["FogInspection"] = "FogInspection";
    ImportEntity["Site"] = "Site";
    ImportEntity["Hazard"] = "Hazard";
    ImportEntity["Contact"] = "Contact";
})(ImportEntity = exports.ImportEntity || (exports.ImportEntity = {}));
var RiskScoreValues;
(function (RiskScoreValues) {
    RiskScoreValues["Low"] = "Low";
    RiskScoreValues["Medium"] = "Medium";
    RiskScoreValues["High"] = "High";
})(RiskScoreValues = exports.RiskScoreValues || (exports.RiskScoreValues = {}));
var CccImportSteps;
(function (CccImportSteps) {
    CccImportSteps["STEP1"] = "choose-a-file";
    CccImportSteps["STEP2"] = "preview";
    CccImportSteps["STEP3"] = "results";
})(CccImportSteps = exports.CccImportSteps || (exports.CccImportSteps = {}));
var ImportEntityPolicy;
(function (ImportEntityPolicy) {
    ImportEntityPolicy["addAndUpdate"] = "AddAndUpdate";
    ImportEntityPolicy["addOnly"] = "AddOnly";
    ImportEntityPolicy["updateOnly"] = "UpdateOnly";
})(ImportEntityPolicy = exports.ImportEntityPolicy || (exports.ImportEntityPolicy = {}));
var FieldUpdatePolicy;
(function (FieldUpdatePolicy) {
    FieldUpdatePolicy["alwaysUpdate"] = "AlwaysUpdate";
    FieldUpdatePolicy["updateOnlyWhenEmpty"] = "UpdateOnlyWhenEmpty";
    FieldUpdatePolicy["neverUpdate"] = "NeverUpdate";
})(FieldUpdatePolicy = exports.FieldUpdatePolicy || (exports.FieldUpdatePolicy = {}));
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["Active"] = "active";
})(ServiceStatus = exports.ServiceStatus || (exports.ServiceStatus = {}));
var TestFrequencySettingTypes;
(function (TestFrequencySettingTypes) {
    TestFrequencySettingTypes["None"] = "None";
    TestFrequencySettingTypes["Hazard"] = "Hazard";
    TestFrequencySettingTypes["Selected"] = "Selected";
})(TestFrequencySettingTypes = exports.TestFrequencySettingTypes || (exports.TestFrequencySettingTypes = {}));
var DeviceCleaningFrequencySettingTypes;
(function (DeviceCleaningFrequencySettingTypes) {
    DeviceCleaningFrequencySettingTypes["None"] = "None";
    DeviceCleaningFrequencySettingTypes["Device"] = "Device";
    DeviceCleaningFrequencySettingTypes["Selected"] = "Selected";
})(DeviceCleaningFrequencySettingTypes = exports.DeviceCleaningFrequencySettingTypes || (exports.DeviceCleaningFrequencySettingTypes = {}));
var TestFrequencySettingFields;
(function (TestFrequencySettingFields) {
    TestFrequencySettingFields["DueDate"] = "DueDate";
    TestFrequencySettingFields["CompleteDate"] = "CompleteDate";
})(TestFrequencySettingFields = exports.TestFrequencySettingFields || (exports.TestFrequencySettingFields = {}));
var DeviceCleaningFrequencySettingFields;
(function (DeviceCleaningFrequencySettingFields) {
    DeviceCleaningFrequencySettingFields["DueDate"] = "DueDate";
    DeviceCleaningFrequencySettingFields["CompleteDate"] = "CompleteDate";
})(DeviceCleaningFrequencySettingFields = exports.DeviceCleaningFrequencySettingFields || (exports.DeviceCleaningFrequencySettingFields = {}));
var DashboardWidgetTypes;
(function (DashboardWidgetTypes) {
    DashboardWidgetTypes["Table"] = "Table";
    DashboardWidgetTypes["DonutChart"] = "DonutChart";
    DashboardWidgetTypes["LineChart"] = "LineChart";
    DashboardWidgetTypes["BarChart"] = "BarChart";
    DashboardWidgetTypes["CountList"] = "CountList";
    DashboardWidgetTypes["CountGrid"] = "CountGrid";
})(DashboardWidgetTypes = exports.DashboardWidgetTypes || (exports.DashboardWidgetTypes = {}));
var DashboardWidgetFilterCategories;
(function (DashboardWidgetFilterCategories) {
    DashboardWidgetFilterCategories["Facilities"] = "Facilities";
    DashboardWidgetFilterCategories["Inspections"] = "Inspections";
    DashboardWidgetFilterCategories["Violations"] = "Violations";
    DashboardWidgetFilterCategories["Devices"] = "Devices";
    DashboardWidgetFilterCategories["Extractors"] = "Extractors";
    DashboardWidgetFilterCategories["Cleanings"] = "Cleanings";
    DashboardWidgetFilterCategories["Events"] = "Events";
    DashboardWidgetFilterCategories["Incidents"] = "Incidents";
})(DashboardWidgetFilterCategories = exports.DashboardWidgetFilterCategories || (exports.DashboardWidgetFilterCategories = {}));
var LinkType;
(function (LinkType) {
    LinkType["inspectionLink"] = "InspectionLink";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
__exportStar(require("./string-extensions"), exports);
var ImportSampleSteps;
(function (ImportSampleSteps) {
    ImportSampleSteps["STEP1"] = "select-data-provider";
    ImportSampleSteps["STEP2"] = "select-file";
    ImportSampleSteps["STEP3"] = "select-data-defaults";
    ImportSampleSteps["STEP4"] = "translate-data";
    ImportSampleSteps["STEP5"] = "preview-import";
})(ImportSampleSteps = exports.ImportSampleSteps || (exports.ImportSampleSteps = {}));
var IndustriesBulkUpdate;
(function (IndustriesBulkUpdate) {
    IndustriesBulkUpdate["STEP1_INPUT_VALUES"] = "inputValues";
    IndustriesBulkUpdate["STEP2_SUMMARY"] = "bulkUpdateSummary";
})(IndustriesBulkUpdate = exports.IndustriesBulkUpdate || (exports.IndustriesBulkUpdate = {}));
var AddNoticeSteps;
(function (AddNoticeSteps) {
    AddNoticeSteps["STEP1"] = "choose-a-name";
    AddNoticeSteps["STEP2"] = "select-recipients";
    AddNoticeSteps["STEP3"] = "edit-content";
    AddNoticeSteps["STEP4"] = "schedule-and-delivery-options";
    AddNoticeSteps["STEP5"] = "preview-and-save";
})(AddNoticeSteps = exports.AddNoticeSteps || (exports.AddNoticeSteps = {}));
var AddGeneralNoticeSteps;
(function (AddGeneralNoticeSteps) {
    AddGeneralNoticeSteps["STEP1"] = "choose-a-name";
    AddGeneralNoticeSteps["STEP2"] = "edit-content";
    AddGeneralNoticeSteps["STEP3"] = "preview-and-save";
})(AddGeneralNoticeSteps = exports.AddGeneralNoticeSteps || (exports.AddGeneralNoticeSteps = {}));
var DeviceCleaningNoticeSteps;
(function (DeviceCleaningNoticeSteps) {
    DeviceCleaningNoticeSteps["STEP1"] = "select-template";
    DeviceCleaningNoticeSteps["STEP2"] = "choose-recipients";
    DeviceCleaningNoticeSteps["STEP3"] = "edit-content";
    DeviceCleaningNoticeSteps["STEP4"] = "preview-send";
})(DeviceCleaningNoticeSteps = exports.DeviceCleaningNoticeSteps || (exports.DeviceCleaningNoticeSteps = {}));
var SendFacilityNoticeSteps;
(function (SendFacilityNoticeSteps) {
    SendFacilityNoticeSteps["STEP1"] = "select-a-template";
    SendFacilityNoticeSteps["STEP2"] = "choose-recipient";
    SendFacilityNoticeSteps["STEP3"] = "edit-content";
    SendFacilityNoticeSteps["STEP4"] = "review-and-send";
})(SendFacilityNoticeSteps = exports.SendFacilityNoticeSteps || (exports.SendFacilityNoticeSteps = {}));
var NoticesType;
(function (NoticesType) {
    NoticesType["DeviceCleaningNotice"] = "DeviceCleaningNotice";
    NoticesType["DeviceGeneralNotice"] = "DeviceGeneralNotice";
})(NoticesType = exports.NoticesType || (exports.NoticesType = {}));
var FacilityBulkNoticeSteps;
(function (FacilityBulkNoticeSteps) {
    FacilityBulkNoticeSteps["STEP1"] = "select-a-template";
    FacilityBulkNoticeSteps["STEP2"] = "choose-recipients";
    FacilityBulkNoticeSteps["STEP3"] = "edit-content";
    FacilityBulkNoticeSteps["STEP4"] = "preview-and-send";
})(FacilityBulkNoticeSteps = exports.FacilityBulkNoticeSteps || (exports.FacilityBulkNoticeSteps = {}));
var Portal;
(function (Portal) {
    Portal["hauler"] = "hauler";
    Portal["facility"] = "facility";
})(Portal = exports.Portal || (exports.Portal = {}));
var ServicePortalType;
(function (ServicePortalType) {
    ServicePortalType["FacilityPortal"] = "FacilityPortal";
    ServicePortalType["HaulerPortal"] = "HaulerPortal";
})(ServicePortalType = exports.ServicePortalType || (exports.ServicePortalType = {}));
var locationValues;
(function (locationValues) {
    locationValues["inside"] = "Inside";
    locationValues["outside"] = "Outside";
})(locationValues = exports.locationValues || (exports.locationValues = {}));
var CustomFormFieldType;
(function (CustomFormFieldType) {
    CustomFormFieldType["Text"] = "Text";
    CustomFormFieldType["TextArea"] = "Textarea";
    CustomFormFieldType["Number"] = "Number";
    CustomFormFieldType["Date"] = "Date";
    CustomFormFieldType["Checkbox"] = "Checkbox";
    CustomFormFieldType["AttachmentControl"] = "AttachmentControl";
    CustomFormFieldType["Signature"] = "Signature";
    CustomFormFieldType["Lookup"] = "Lookup";
    CustomFormFieldType["CustomSelect"] = "Custom Select";
})(CustomFormFieldType = exports.CustomFormFieldType || (exports.CustomFormFieldType = {}));
var CustomCleaningFields;
(function (CustomCleaningFields) {
    CustomCleaningFields["DueDate"] = "Due date";
    CustomCleaningFields["CompleteDate"] = "Complete date";
    CustomCleaningFields["ManifestNumber"] = "Manifest number";
    CustomCleaningFields["WasteType"] = "Waste type";
    CustomCleaningFields["VolumeOfWasteRemoved"] = "Volume of waste removed";
    CustomCleaningFields["PercentGreaseCalculator"] = "Percent grease calculator";
    CustomCleaningFields["DeviceDepth"] = "Device depth";
    CustomCleaningFields["FOG"] = "FOG depth";
    CustomCleaningFields["Solids"] = "Solids depth";
    CustomCleaningFields["FogLeavingOutlet"] = "Fog leaving outlet";
    CustomCleaningFields["Hauler"] = "Hauler";
    CustomCleaningFields["DriverName"] = "Driver name";
    CustomCleaningFields["CleaningBy"] = "Cleaned by";
    CustomCleaningFields["vehicleNumber"] = "Vehicle number";
    CustomCleaningFields["InNeedOfRepair"] = "In need of repair";
    CustomCleaningFields["Attachments"] = "Attachments";
    CustomCleaningFields["Comments"] = "Comments";
    CustomCleaningFields["Certification"] = "Certification";
    CustomCleaningFields["Signature"] = "Signature";
})(CustomCleaningFields = exports.CustomCleaningFields || (exports.CustomCleaningFields = {}));
var CustomFormType;
(function (CustomFormType) {
    CustomFormType["AuthorityCleaningForm"] = "AuthorityCleaningForm";
    CustomFormType["HaulerCleaningForm"] = "HaulerCleaningForm";
    CustomFormType["FacilityCleaningForm"] = "FacilityCleaningForm";
})(CustomFormType = exports.CustomFormType || (exports.CustomFormType = {}));
var ScreenViewPort;
(function (ScreenViewPort) {
    ScreenViewPort["desktop"] = "desktop";
    ScreenViewPort["mobile"] = "mobile";
    ScreenViewPort["tablet"] = "tablet";
})(ScreenViewPort = exports.ScreenViewPort || (exports.ScreenViewPort = {}));
var NullValues;
(function (NullValues) {
    NullValues["Empty"] = "Empty";
    NullValues["Null"] = "null";
})(NullValues = exports.NullValues || (exports.NullValues = {}));
__exportStar(require("./import"), exports);
__exportStar(require("./string-extensions"), exports);
//# sourceMappingURL=index.js.map